import { render, staticRenderFns } from "./DieticianAdviceCard.vue?vue&type=template&id=0d3e0cba&scoped=true&"
import script from "./DieticianAdviceCard.vue?vue&type=script&lang=js&"
export * from "./DieticianAdviceCard.vue?vue&type=script&lang=js&"
import style0 from "./DieticianAdviceCard.vue?vue&type=style&index=0&id=0d3e0cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e0cba",
  null
  
)

export default component.exports